export default __webpack_public_path__ + "static/media/spacefit1.2e8e6515.jpg";